import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export type CompleteOnboardingOutput = {
  completed: boolean;
  submission_id: string;
  error: string;
  errorCode?: string;
};

export type CompleteOnboardingInput = {
  matchId: string;
  providerId: string;
  timeStart: string;
};

export const completeOnboarding = (data: CompleteOnboardingInput) =>
  restClient.request<CompleteOnboardingOutput>('/onboarding/complete', {
    method: 'POST',
    data: snakecaseKeys(data),
  });
